<script setup>
import { onMounted, ref } from "vue";
import { useTreeStore } from '@/store/modules/trees.js';
import { KNOLIA } from "@/knolia";
import DepthElement from "@/components/DepthElement";
import MetaContainer from "@/components/MetaContainer";
import ActivitiesList from "@/components/ActivitiesList";
import SkillsTable from "@/components/SkillsTable";
import { onBeforeRouteLeave } from "vue-router";
import { Gems } from "@/gems";
import TreeType from "@/enums/TreeType"

const store = useTreeStore()
const activitiesArr = ref([])

function SearchInList() {
  store.filterLists(TreeType.TASKS)
  store.filterLists(TreeType.SKILLS)
}

async function NewMeta() {
  await KNOLIA.CallBackEnd("post", "control-tree-element", {
    update: "meta",
    treeType: TreeType.TASKS,
    name: "[Novo Elemento]",
  })

  store.UpdateTasksTree()
}

onMounted(() => {
  store.GetTasksDepth();

  store.GetActivities();

  store.GetSkills({ treeType: "tasks" });

  Gems.Tooltip(document.getElementById("newMeta"), "Novo elemento", "tooltip");
  KNOLIA.ResizeSplitScreen(document.getElementById("separator"), "V");
});

onBeforeRouteLeave(() => {
  store.resetTree();
});
</script>

<template>
  <div class="splitter page-container">
    <div id="first" class="top">
      <div class="filter col-12">
        <input type="text" class="w-100" v-model="store.searchFilter" placeholder="Filtrar..." @keyup="SearchInList"/>
      </div>
      <div class="lists scrollbar row">
        <ActivitiesList class="col-6" :elements="activitiesArr" />
        <SkillsTable class="col-6" />
      </div>
    </div>
    <div id="separator" class="separator"></div>
    <div id="second" class="bottom scrollbar">
      <div class="table-container">
        <div>
          <section class="meta-comp-section">
            
            <div class="div-meta-title">
              <span class="meta-title">META ATIVIDADES</span>
              <i id="newMeta" class="fa fa-plus-circle i-add-elem" @click="NewMeta"></i>
            </div>

            <div class="meta-comp-container">
              <span v-for="(column, index) in store.Tree" :key="column.id" class="meta-comp-item">
                <DepthElement
                  :element="column"
                  :column-depth="column.totalDepth"
                  :meta-id="column.elem_id"
                  :is-meta="true"
                  :tree-type="TreeType.TASKS"
                  :index="index"
                />
              </span>
            </div>
          </section>
        </div>
        <MetaContainer :tree-type="TreeType.TASKS" @element-dropped="SearchInList()"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '../components/assets/styles/trees-style.css';

.top {
  display: flex;
  flex-direction: column;
}

.lists {
  margin-bottom: 10px;
  width: 100%;
}

.filter {
  cursor: pointer;
  margin-bottom: 20px;
}

.btn-filter {
  height: 32px;
  line-height: 1px;
  flex: 1;
}

.filter input {
  flex: 3;
}

.filter input::placeholder {
  color: var(--default-font-color);
}

@media screen and (max-width: 765px) {
  .top,
  .bottom {
    height: 45vh;
  }

}
</style>
